import { DecodedValueMap, StringParam } from 'use-query-params';
import { ArrayParam } from 'react-router-url-params';
import { TagFiltersParam } from '../patientTags/TagFiltersParam';
import { createPagingParams } from 'src/helpers/pagination-helper';

export const studyUsersFilterParams = () => ({
  roles: ArrayParam,
  favoriteUserIds: ArrayParam,
  searchQuery: StringParam,
  tags: TagFiltersParam,
});

export const defaultQueryParams: Partial<DecodedValueMap<typeof usersQueryParamsConfig>> = {
  page: 1,
  roles: undefined,
  searchQuery: undefined,
  favoriteUserIds: undefined,
  sortBy: 'lastVisitDate',
  tags: undefined,
  desc: true,
  perPage: 20,
};

export const usersQueryParamsConfig = {
  ...createPagingParams({
    sortingKeys: ['fullName', 'lastVisitDate'],
    defaultSortBy: 'lastVisitDate',
    defaultDesc: true,
    defaultPerPage: 20,
  }),
  ...studyUsersFilterParams(),
};

export type GetStudyUsersQueryParameters = {
  roles?: string[] | null;
  favoriteUserIds?: string[] | null;
  searchQuery?: string | null;
  tags?: Record<string, string[]>;
};

export const studyUsersFilterToBackendRequest = (query: {
  roles?: (string | null)[] | null;
  favoriteUserIds?: (string | null)[] | null;
  searchQuery?: string | null;
  tags?: Record<string, string[]>;
}): GetStudyUsersQueryParameters => ({
  roles: query.roles?.length ? (query.roles.filter(Boolean) as string[]) : undefined,
  searchQuery: query.searchQuery ?? undefined,
  favoriteUserIds: query.favoriteUserIds?.length ? (query.favoriteUserIds.filter(Boolean) as string[]) : undefined,
  tags: query.tags,
});
